<template>
  <div>
    <!-- 有地址 -->
    <template v-if="Object.keys(data.recipient).length">
      <!-- 有地址有物流公司 -->
      <template v-if="data.expressCompany">
        <!-- 有地址有物流公司有物流 -->
        <div class="lld-all-wrap" v-if="data.tracks.length">
          <van-nav-bar
            :class="[
              'lld-rewrite-am-navbar-light',
              not_iphonex
                ? 'notrem-lld-rewrite-am-navbar-light-notiphonex'
                : '',
              iphonex && !not_iphonex
                ? 'notrem-lld-rewrite-am-navbar-light-iphonex'
                : '',
            ]"
            title="物流信息"
            left-arrow
            @click-left="goBack"
          />
          <div
            :class="[
              'lld-header-wrap',
              not_iphonex ? 'notrem-lld-header-wrap-notiphonex' : '',
              iphonex && !not_iphonex ? 'notrem-lld-header-wrap-iphonex' : '',
            ]"
          >
            <p class="lld-header-p">
              <span class="lld-header-span">快递公司</span
              >{{ data.expressCompanyName }}
            </p>
            <p class="lld-header-p">
              <span class="lld-header-span">快递单号</span
              >{{ data.expressNum[0] }}<span class="shu">|</span
              ><button
                class="lld-header-span-hightLight"
                id="copyBtn"
                :data-clipboard-text="data.expressNum[0]"
                @click="copyHandle"
              >
                复制
              </button>
            </p>
            <p>
              <span class="lld-header-span">发货时间</span
              >{{ data.outStockTime }}
            </p>
          </div>
          <div class="lld-logistics-space"></div>
          <div class="lld-flow-wrap">
            <div class="am-steps am-steps-vertical">
              <div
                v-for="(v, i) in data.tracks"
                :class="[
                  'am-steps-item am-steps-item-process am-steps-item-custom',
                  data.status == '4'
                    ? i == 1 || i == 0
                      ? 'lld-rewrite-step-hightlight'
                      : i == 1
                      ? 'lld-rewrite-step-hightlight'
                      : 'lld-rewrite-step'
                    : 'lld-rewrite-step',
                ]"
                :key="i"
              >
                <div class="am-steps-item-tail"></div>
                <div class="am-steps-item-icon">
                  <span class="am-steps-icon">
                    <template v-if="data.status == '4'">
                      <img
                        v-if="i == 0"
                        src="../../assets/img/myPackage/get.png"
                        class="otherImg"
                      />
                      <img
                        v-else-if="i == 1"
                        src="../../assets/img/myPackage/right.png"
                        class="otherImg"
                      />
                      <img
                        v-else
                        src="../../assets/img/myPackage/flowGrey.png"
                        class="flowImg"
                      />
                    </template>
                    <template v-else>
                      <img
                        v-if="i == 0"
                        src="../../assets/img/myPackage/getGrey.png"
                        class="otherImg"
                      />
                      <img
                        v-else-if="i == 1"
                        src="../../assets/img/myPackage/flow.png"
                        class="flowImg"
                      />
                      <img
                        v-else
                        src="../../assets/img/myPackage/flowGrey.png"
                        class="flowImg"
                      />
                    </template>
                  </span>
                </div>
                <div class="am-steps-item-content">
                  <div
                    class="am-steps-item-title"
                    v-html="v.operateInfo || ''"
                  ></div>
                  <div class="am-steps-item-description">
                    {{ v.operateTime || "" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 有地址有物流公司无物流 -->
        <div class="lld-all-wrap" v-else>
          <van-nav-bar
            title="物流信息"
            left-arrow
            @click-left="goBack"
            :class="[
              'lld-rewrite-am-navbar-light',
              not_iphonex
                ? 'notrem-lld-rewrite-am-navbar-light-notiphonex'
                : '',
              iphonex && !not_iphonex
                ? 'notrem-lld-rewrite-am-navbar-light-iphonex'
                : '',
            ]"
          />
          <div
            :class="[
              'lld-header-wrap',
              not_iphonex ? 'notrem-lld-header-wrap-notiphonex' : '',
              iphonex && !not_iphonex ? 'notrem-lld-header-wrap-iphonex' : '',
            ]"
          >
            <p class="lld-header-p">
              <span class="lld-header-span">快递公司</span
              >{{ data.expressCompanyName }}
            </p>
            <p class="lld-header-p">
              <span class="lld-header-span">快递单号</span
              >{{ data.expressNum[0] }}<span class="shu">|</span
              ><button
                class="lld-header-span-hightLight"
                id="copyBtn"
                :data-clipboard-text="data.expressNum[0]"
                @click="copyHandle"
              >
                复制
              </button>
            </p>
            <p>
              <span class="lld-header-span">发货时间</span
              >{{ data.outStockTime }}
            </p>
          </div>
          <div class="lld-logistics-space"></div>
          <div class="lld-header-wrap-flow">
            <p class="lld-header-p">
              收货信息：{{ data.recipient.name }} {{ data.recipient.phone }}
            </p>
            <p class="lld-header-p-line-height">
              {{ data.recipient.provinceName }}{{ data.recipient.cityName
              }}{{ data.recipient.countyName }}{{ data.recipient.detail }}
            </p>
          </div>
          <div style="text-align: center">
            <img
              src="../../assets/img/myPackage/noPackage.png"
              class="noPackageImg"
              alt="暂无物流信息"
            />
            <p class="noPackageText">暂无物流信息</p>
          </div>
        </div>
      </template>
      <!-- 有地址没物流公司 -->
      <div class="lld-all-wrap" v-else>
        <van-nav-bar
          title="物流信息"
          left-arrow
          @click-left="goBack"
          :class="[
            'lld-rewrite-am-navbar-light',
            not_iphonex ? 'notrem-lld-rewrite-am-navbar-light-notiphonex' : '',
            iphonex && !not_iphonex
              ? 'notrem-lld-rewrite-am-navbar-light-iphonex'
              : '',
          ]"
        />
        <div
          :class="[
            'lld-header-wrap',
            not_iphonex ? 'notrem-lld-header-wrap-notiphonex' : '',
            iphonex && !not_iphonex ? 'notrem-lld-header-wrap-iphonex' : '',
          ]"
        >
          <p class="lld-header-p">
            收货信息：{{ data.recipient.name }} {{ data.recipient.phone }}
          </p>
          <p class="lld-header-p-line-height">
            {{ data.recipient.provinceName }}{{ data.recipient.cityName
            }}{{ data.recipient.countyName }}{{ data.recipient.detail }}
          </p>
        </div>
        <div class="line"></div>
        <div style="text-align: center">
          <img
            src="../../assets/img/myPackage/noPackage.png"
            class="noPackageImg"
            alt="暂无物流信息"
          />
          <p class="noPackageText">暂无物流信息</p>
        </div>
      </div>
    </template>
    <!-- 无地址 -->
    <div
      v-if="Object.keys(data.recipient).length == 0 && !loading"
      style="text-align: center"
      class="lld-all-wrap"
    >
      <van-nav-bar
        title="物流信息"
        left-arrow
        @click-left="goBack"
        :class="[
          'lld-rewrite-am-navbar-light',
          not_iphonex ? 'notrem-lld-rewrite-am-navbar-light-notiphonex' : '',
          iphonex && !not_iphonex
            ? 'notrem-lld-rewrite-am-navbar-light-iphonex'
            : '',
        ]"
      />
      <img
        src="../../assets/img/myPackage/noPackage.png"
        :class="[
          'lld-header-wrap-empty',
          not_iphonex ? 'notrem-lld-header-wrap-empty-notiphonex' : '',
          iphonex && !not_iphonex ? 'notrem-lld-header-wrap-empty-iphonex' : '',
        ]"
        alt="暂无物流信息"
      />
      <p class="noPackageText">暂无物流信息</p>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import Clipboard from "clipboard";
import appUtil from "../../utils/appUtil";
export default {
  name: "logisticsDetail",
  data() {
    return {
      bizId: "",
      tab: "",
      data: {
        expressNum: [],
        tracks: [],
        recipient: {},
      },
      clipboard: {},
      from: "",
      otmsOrderNum: "",
      not_iphonex: window.navigator.userAgent.includes("not_iphonex"),
      iphonex: window.navigator.userAgent.includes("iphonex"),
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      loading: "getLoading",
    }),
  },
  created() {
    let isApp = new appUtil().isApp();
    if (isApp == "android" || isApp == "ios") {
      window.dhsdk.isShowNavigation({
        show: false,
      });
    }
  },
  mounted() {
    this.tab = this.$route.query.tab ? this.$route.query.tab : "";
    this.from = this.$route.query.from ? this.$route.query.from : "";
    this.bizId = this.$route.query.bizId ? this.$route.query.bizId : "";
    this.otmsOrderNum = this.$route.query.otmsOrderNum
      ? this.$route.query.otmsOrderNum
      : "";
    if (!this.bizId) {
      this.$toast("获取bizId异常");
      return;
    }
    this.getData();
    window.scrollTo(0, 0);
  },
  methods: {
    ...mapMutations({
      changeLoading: "changeLoading",
    }),
    goBack() {
      if (this.tab) {
        if (this.from == "multiple") {
          history.go(-1);
        } else {
          window.location.replace(
            `${location.origin}${location.pathname}#/myPackage?tab=${this.tab}`
          );
        }
      } else {
        if (this.from == "multiple") {
          history.go(-1);
        } else {
          window.dhsdk.finishInterface();
        }
      }
    },
    // 复制链接
    copyHandle() {
      let _this = this;
      let clipboard = new Clipboard("#copyBtn"); // 这里括号里填写上面点击事件绑定的class名
      clipboard.on("success", (e) => {
        e.clearSelection();
        // 复制成功，提示根据自己项目实际使用的UI来写
        _this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", () => {
        // 不支持复制，提示根据自己项目实际使用的UI来写
        _this.$toast("复制失败，请重新尝试");
        // 释放内存
        clipboard.destroy();
      });
    },
    // 获取物流信息
    getData() {
      this.changeLoading(true);
      this.$api.my
        .getLogisticsDetail({
          bizId: this.bizId,
          otmsOrderNum: this.otmsOrderNum,
        })
        .then((res) => {
          this.changeLoading(false);

          if (res.ret) {
            let data = res.data;
            if (data.tracks.length) {
              data.tracks.map((val) => {
                val.operateInfo = val.operateInfo.replace(
                  /[\d-]{11,}/g,
                  (v) => {
                    return `<a style="display:inline-block;color:#1082FF;" href='tel:${v}'>${v}</a>`;
                  }
                );
                return val;
              });
              data.tracks.unshift({
                operateInfo: `收货信息：${data.recipient.name} ${data.recipient.phone}<br>${data.recipient.provinceName}${data.recipient.cityName}${data.recipient.countyName}${data.recipient.detail}`,
              });
            }
            this.data = data;
          } else {
            this.$toast(res.msg);
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.fixNav {
  color: #333;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 999;
  height: 44px;
  box-sizing: content-box;
  border-bottom: 1px solid #f3f3f3;
}
.noPackageImg {
  width: 100px;
  margin-top: 90px;
}
.noPackageText {
  margin-top: 16px;
  color: #333333;
}
.lld-all-wrap {
  background-color: #fff;
  height: 100%;
  .lld-header-wrap,
  .lld-header-wrap-flow {
    color: #333;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    padding: 20px;
    p {
      line-height: 14px;
    }
    .lld-header-p-line-height {
      line-height: 20px;
      margin: -1px 0 -2px;
    }
    .lld-header-span {
      color: #666;
      margin-right: 10px;
    }
    .shu {
      margin: 0 10px;
      color: #e2e2e2;
      font-size: 13px;
    }
    .lld-header-span-hightLight {
      color: #1082ff;
      background-color: transparent;
      border-width: 0;
      border-style: none;
    }
    .lld-header-p {
      margin-bottom: 10px;
    }
  }
  .lld-header-wrap {
    padding-top: 64px; // 0.4+0.88
  }
  .notrem-lld-header-wrap-iphonex {
    padding-top: calc(1.7rem + 40px);
  }
  .notrem-lld-header-wrap-notiphonex {
    padding-top: calc(1.7rem + 20px);
  }
  .lld-header-wrap-empty {
    width: 100px;
    margin-top: 134px;
    .notrem-lld-header-wrap-empty-iphonex {
      margin-top: calc(2.4rem + 1.17333rem + 40px);
    }
    .notrem-lld-header-wrap-empty-notiphonex {
      margin-top: calc(2.4rem + 1.17333rem + 20px);
    }
  }
  .line {
    height: 1px;
    margin: 0 20px;
    background-color: #f0f0f0;
  }
}
.lld-rewrite-step,
.lld-rewrite-step-hightlight {
  .am-steps-item-content {
    .am-steps-item-title {
      font-size: 14px !important;
      color: #999 !important;
      font-family: PingFangSC-Regular, PingFang SC !important;
      font-weight: 400 !important;
    }
    .am-steps-item-description {
      font-size: 12px !important;
      color: #999 !important;
      font-family: PingFangSC-Regular, PingFang SC !important;
      font-weight: 400 !important;
    }
  }
  .am-steps-item-tail {
    padding: 0 !important;
    left: 11px !important;
  }
  .am-steps-item-tail:after {
    background-color: transparent !important;
    background: transparent !important;
    top: 12px !important;
    border-right: 1px dashed #e2e2e2 !important;
    left: 0 !important;
    width: 0 !important;
  }
  .am-steps-item-icon {
    margin-right: 10px !important;
  }
  .am-steps-item-icon > .am-steps-icon {
    top: 0 !important;
  }
}
.lld-rewrite-step-hightlight {
  .am-steps-item-content {
    .am-steps-item-title {
      color: #333 !important;
    }
  }
}
.lld-rewrite-am-navbar-light {
  color: #333;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 999;
  height: 44px;
  box-sizing: content-box;
  border-bottom: 1px solid #f3f3f3;
}
.notrem-lld-rewrite-am-navbar-light-iphonex {
  padding-top: 40px;
}
.notrem-lld-rewrite-am-navbar-light-notiphonex {
  padding-top: 20px;
}
.lld-logistics-space {
  background-color: #f8f8f8;
  height: 10px;
}
.lld-flow-wrap {
  padding: 20px;
  word-break: break-all;
}

.am-steps,
.am-steps * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.am-steps {
  font-size: 0;
  width: 100%;
  line-height: 1.5;
  box-sizing: border-box;
}
.am-steps-vertical {
  display: block;
}
.am-steps-item {
  position: relative;
  display: inline-block;
  vertical-align: top;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.am-steps-vertical .am-steps-item {
  display: block;
  overflow: visible;
}
.am-steps-vertical .am-steps-item-tail {
  position: absolute;
  left: 13px;
  top: 0;
  height: 100%;
  width: 1px;
  padding: 30px 0 4px;
}
.am-steps-item-tail:after {
  content: "";
  display: inline-block;
  background: #ddd;
  height: 1px;
  border-radius: 1px;
  width: 100%;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
  position: relative;
  left: -2px;
}
.am-steps-vertical .am-steps-item-tail:after {
  height: 100%;
  width: 1px;
}
.am-steps-item-process .am-steps-item-tail:after {
  background-color: #ddd;
}
.am-steps-item-content,
.am-steps-item-icon {
  display: inline-block;
  vertical-align: top;
}
.am-steps-item-icon {
  border: 1px solid #bbb;
  width: 22px;
  height: 22px;
  line-height: 22px;
  border-radius: 22px;
  text-align: center;
  font-size: 14px;
  margin-right: 8px;
  -webkit-transition: background-color 0.3s, border-color 0.3s;
  transition: background-color 0.3s, border-color 0.3s;
}
.am-steps-item-process .am-steps-item-icon {
  border-color: #108ee9;
  background-color: #fff;
}
.am-steps-item-custom .am-steps-item-icon {
  background: 0 0;
  border: 0;
  width: auto;
  height: auto;
}

.am-steps-vertical .am-steps-item-icon {
  float: left;
}

.am-steps-item-custom.am-steps-item-process
  .am-steps-item-icon
  > .am-steps-icon {
  color: #108ee9;
}

.am-steps-item-custom .am-steps-item-icon > .am-steps-icon {
  font-size: 22px;
  top: 1px;
  width: 22px;
  height: 22px;
}

.am-steps-item-icon > .am-steps-icon {
  line-height: 1;
  top: -1px;
  color: #108ee9;
  position: relative;
}
.am-steps-item-process .am-steps-item-icon > .am-steps-icon {
  color: #fff;
}

.am-icon {
  fill: currentColor;
  background-size: cover;
  width: 22px;
  height: 22px;
}
.am-icon-md {
  width: 22px;
  height: 22px;
}

svg:not(:root) {
  overflow: hidden;
}
.am-steps-item-icon > .am-steps-icon .am-icon {
  font-size: 12px;
  position: relative;
  float: left;
}
.am-steps-item-content {
  margin-top: 3px;
}

.am-steps-vertical .am-steps-item-content {
  min-height: 48px;
  overflow: hidden;
  display: block;
}
.am-steps-item-title {
  font-size: 16px;
  margin-bottom: 4px;
  color: #000;
  font-weight: 700;
  display: inline-block;
  padding-right: 10px;
  position: relative;
}
.am-steps-item-process .am-steps-item-title {
  color: #000;
}

.am-steps-vertical .am-steps-item-title {
  line-height: 26px;
}
.am-steps-item-description {
  font-size: 15px;
  color: #bbb;
}
.am-steps-item-process .am-steps-item-description {
  color: #000;
}

.am-steps-vertical .am-steps-item-description {
  padding-bottom: 12px;
}
.flowImg {
  width: 24px;
  padding: 5px;
}
.otherImg {
  width: 24px;
}
.am-steps-item:nth-last-of-type(1) .am-steps-item-tail::after {
  content: none;
}
</style>
